import { JourneysLegacyAuthRefreshRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/reset_password/$')({
  component: JourneysLegacyAuthRefreshRoute,
});
